export enum EntityViewTypes {
    search = "search",
    list = "list",
    writableList = "writableList",
    documentList = "documentList",
    addressBook = "addressBook",
    chart = "graph",
    storageSummaryChart = "storageSummaryChart",
    notImplemented = "notImplemented"
}